"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.saveCustomerMutation = exports.updateCustomerInfoMutation = exports.updateCustomerOrderMutation = void 0;
const types_1 = require("../../types");
exports.updateCustomerOrderMutation = `
  mutation updateCustomerOrder($id: String!, $bosApiId: String!) {
    updateCustomerOrder(orderId: $id, bosApiId: $bosApiId) {
      ...customer
    }
  }
  ${types_1.customerFragments}
`;
exports.updateCustomerInfoMutation = `
  mutation updateCustomer($id: String!, $input: CustomerInput!) {
    updateCustomer(id: $id, input: $input) {
      ...customer
    }
  }
  ${types_1.customerFragments}
`;
exports.saveCustomerMutation = `
  mutation saveCustomer($orderId: ID!, $input: BosApiCustomerInput!) {
    saveCustomer(orderId: $orderId, input: $input) {
      ... on Order {
          id
          customer {
           ...customer
          }
      }
     ... on NextError {
         ...nextError
     } 
    }
  }
  ${types_1.customerFragments}
  ${types_1.nextErrorFragment}
`;
//# sourceMappingURL=customer.js.map